module.exports = __webpack_public_path__ + "static/media/galleryGT (2).a2a5fd79.jpg";